<template>
  <div v-if="reservation" class="opacity-90">
    <div class="relative px-1 flex flex-col rounded-md border divide-y dark:border-gray-800 dark:divide-gray-800 dark:bg-gray-800/50">
      <template v-for="service in services" :key="service.idReservationService">
        <price-service
          v-if="service.service"

          :service="service"
          v-model:reservation="_reservation"
          @editDiscount="handleEditDiscount"
        />
      </template>
    </div>

    <discount-dialog
      v-if="!isReservationCustomer"
      ref="discountDialog"
      v-model:reservation="_reservation"
    />

    <reservation-customer-discount-dialog
      v-if="isReservationCustomer"
      ref="discountDialog"
      v-model:reservation="_reservation"
    />
  </div>
</template>

<script setup lang="ts">
import PriceService from '@/components/reservation/edit/PriceService.vue'
import DiscountDialog from '@/components/reservation/actions/Discount.vue'
import ReservationCustomerDiscountDialog from '@/components/reservationCustomer/actions/Discount.vue'

import {
  ODescriptionDetails,
  ODropdownItem,
} from '@/components/elements'

import {
  TextField,
  CurrencyField,
  NumberField,
  CheckboxGroupField,
} from '@/components/fields'

import { ReservationCustomer } from '@/_api/models/reservationCustomer'

interface Props {
  reservation?: Record<string, any> | null
}

interface Emits {
  (e: 'update:reservation', value: any): void
}

const props = withDefaults(defineProps<Props>(), {
  reservation: null,
})

const emit = defineEmits<Emits>()

const discountDialog = ref<any>()

const _reservation = computed({
  get () {
    return props.reservation
  },
  set (value) {
    emit('update:reservation', value)
  },
})

const isReservationCustomer = computed(() => {
  return props.reservation instanceof ReservationCustomer
})

const services = computed(() => {
  const reservation = props.reservation as any

  if (reservation.reservation && reservation.reservation.services.length) {
    const service = reservation.reservation.services[0]
    reservation.service = service.service
    reservation.employee = service.employee
    return [reservation]
  }

  if (reservation.services.length) {
    return reservation.services
  }

  return [props.reservation]
})

function handleEditDiscount () {
  discountDialog.value.open()
}
</script>
